import React, { useEffect, useRef, useState } from "react";
import {
  Wrapper,
  Popup,
  BackgroundOverlay,
  PopupHeader,
  Reset,
  TitleSection,
  Title,
  FilterBodyContainer,
  CheckboxContainer,
  CheckboxLabel,
  StyledButton,
  OptionsList,
  Option,
  RightPopup,
  Footer,
  FilterIconWrapper,
  ArrowWrapper,
} from "./AdvanceFilterComp.styled";
import { ReactComponent as TripleLineOptions } from "../../Assets/Icons/TripleLineOptions.svg";
import { ReactComponent as FilterOptions } from "../../Assets/Icons/FilterOptions.svg";
import { ReactComponent as Arrow } from "../../Assets/Icons/Arrow.svg";
import { isValidUSZipCode, viewSizeCalculator } from "../../utils";
import { AdvancedFilterMap } from "../../Assets/MockData/index";
import Locations from "./components/Locations";
import Facilities from "./components/Facilities";
import OncologyFocus from "./components/OncologyFocus";
import FinancialAndOperational from "./components/FinancialAndOperational";
import Reputation from "./components/Reputation";
import Affiliations from "./components/Affiliations";
import Accreditations from "./components/Accreditations";
import QualityOfCare from "./components/QualityOfCare";
import PatientExperience from "./components/PatientExperience";
import AccessibilityAndInclusivity from "./components/AccessibilityAndInclusivity";
import { Filters } from "../../Configs/config";
import { Loader } from "../../App";
import SearchHistory from "./components/SearchHistory";
import SaveSearchModal from "./components/SaveSearchModal";
import Info from "../Info";
import { useDispatch } from "react-redux";

const searchHistoryData = [
  {
    id: 1,
    title: "Evergreen (Finances List)",
    filteredData: { cbsa: "36420" },
  },
  { id: 2, title: "Search 2", filteredData: { state: "ok" } },
  {
    id: 3,
    title: "Revenue > $ 2B",
    filteredData: {
      urban_rural_flag: "Urban",
    },
  },
  {
    id: 4,
    title: "Search 3",
    filteredData: {
      zip_code: "73104",
    },
  },
];

const AdvanceFilterComponent = ({
  isVisible,
  setIsAdvancedFilterVisible,
  filteredData,
  setFilteredData,
  handleInputChange,
  fetchFilteredHospitalsData,
  showloader,
  suggestionsList,
  suggestionsLoader,
  handleReset,
  resetUrl,
  isSaveAndApply,
  setIsSaveAndApply,
  editSavedSearch,
  onCancel,
  isFetching,
}) => {
  const [isPopupVisible, setIsPopupVisible] = useState(isVisible || false);
  const [isSaveSearchChecked, setIsSaveSearchChecked] = useState(false);
  const [isOpenSaveModal, setIsOpenSaveModal] = useState(false);
  const [searchHistory, setSearchHistory] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [selectedSearchItemId, setSelectedSearchItemId] = useState(null);
  const [footerBottom, setFooterBottom] = useState(4.3);
  const [activeNav, setActiveNav] = useState({
    Location: true,
    Facilities: false,
    "Oncology Focus": false,
    "Financial & Operational": false,
    Reputation: false,
    Affiliations: false,
    Accreditations: false,
    "Quality of Care": false,
    "Patient Experience": false,
    "Accessibility & Inclusivity": false,
    "Search History": false,
  });

  const locationRef = useRef(null);
  const facilitiesRef = useRef(null);
  const oncologyRef = useRef(null);
  const financialAndOperationalRef = useRef(null);
  const reputationRef = useRef(null);
  const affiliationsRef = useRef(null);
  const accreditationsRef = useRef(null);
  const qualityOfCareRef = useRef(null);
  const patientExperienceRef = useRef(null);
  const accessibilityAndInclusivityRef = useRef(null);
  const searchHistoryRef = useRef(null);

  const rightPopupRef = useRef(null);

  const [dropdownSuggestions, setDropdownSuggestions] = useState({});
  const [matchedHospital, setMatchedHospital] = useState(null);

  const handleFieldSuggestionsChange = (fieldName, suggestions) => {
    setDropdownSuggestions((prev) => ({
      ...prev,
      [fieldName]: suggestions,
    }));
  };

  const filterRefs = {
    [Filters.LOCATION]: locationRef,
    [Filters.FACILITIES]: facilitiesRef,
    [Filters.ONCOLOGY_FOCUS]: oncologyRef,
    [Filters.FINANCIAL_AND_OPERATIONAL]: financialAndOperationalRef,
    [Filters.REPUTATION]: reputationRef,
    [Filters.AFFILIATIONS]: affiliationsRef,
    [Filters.ACCREDITATIONS]: accreditationsRef,
    [Filters.QUALITY_OF_CARE]: qualityOfCareRef,
    [Filters.PATIENT_EXPERIENCE]: patientExperienceRef,
    [Filters.ACCESSIBILITY_AND_INCLUSIVITY]: accessibilityAndInclusivityRef,
    [Filters.SEARCH_HISTORY]: searchHistoryRef,
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const storedHistory = localStorage.getItem("searchHistory");
    if (storedHistory) {
      setSearchHistory(JSON.parse(storedHistory));
    } else {
      setSearchHistory([]);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("searchHistory", JSON.stringify(searchHistory));
  }, [searchHistory]);

  const scrollToFilterSection = (selectedFilter) => {
    setActiveNav((prevNavState) =>
      Object.keys(prevNavState).reduce(
        (updatedNavState, key) => ({
          ...updatedNavState,
          [key]: key === selectedFilter,
        }),
        {},
      ),
    );

    const targetSectionRef = filterRefs[selectedFilter] || locationRef;

    if (targetSectionRef?.current) {
      const targetElement = targetSectionRef.current;
      const parentContainer = targetElement.parentElement;
      const topOffset = 30;

      parentContainer.scrollTo({
        top: targetElement.offsetTop - topOffset,
        behavior: "smooth",
      });
    }
  };

  const handleScroll = () => {
    if (!rightPopupRef.current) return;

    const scrollPosition = rightPopupRef.current.scrollTop + 100;
    let activeSection = null;

    for (const [filter, ref] of Object.entries(filterRefs)) {
      if (ref.current) {
        const elementTop = ref.current.offsetTop;
        const elementBottom = elementTop + ref.current.offsetHeight;

        if (scrollPosition >= elementTop && scrollPosition <= elementBottom) {
          activeSection = filter;
          break;
        }
      }
    }

    if (activeSection) {
      setActiveNav((prevNavState) => {
        const newState = Object.keys(prevNavState).reduce((acc, key) => {
          acc[key] = key === activeSection;
          return acc;
        }, {});
        return newState;
      });
    }
  };

  useEffect(() => {
    if (rightPopupRef.current) {
      rightPopupRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (rightPopupRef.current) {
        rightPopupRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const handleFilterClick = () => {
    setIsPopupVisible((prev) => !prev);
  };

  const handleFilterApplied = async () => {
    // if (isSaveSearchChecked) {
    //   setIsOpenSaveModal(true);
    //   setEditingItem(null);
    // } else {
    //   await applyingFilters();
    // }
    if (isSaveSearchChecked) {
      const storedData = JSON.parse(localStorage.getItem("searchHistory"));
      storedData[storedData.length - 1]["filteredData"] = filteredData;
      localStorage.setItem("searchHistory", JSON.stringify(storedData));
    }
    await applyingFilters();
    setIsSaveSearchChecked(false);
  };

  const handleSaveSearch = async () => {
    setIsOpenSaveModal(true);
    setEditingItem(null);
  };

  // Handle radio button change
  const handleRadioChange = (event) => {
    setFilteredData({
      ...filteredData,
      urban_rural_flag: event.target.value,
    });
  };

  const isDisabled = (data) => {
    const isEmpty = Object.values(data).every((value) =>
      value === "" ||
      value === null ||
      value === undefined ||
      (typeof value === "object" && !value?.checked) ||
      (data?.zip_code && !isValidUSZipCode(data?.zip_code))
    );

    const isInvalidRange = (minKey, maxKey) => {
      const min = parseFloat(data[minKey]);
      const max = parseFloat(data[maxKey]);
      return !isNaN(min) && !isNaN(max) && min > max;
    };

    const invalidMinMax = [
      ["bed_count_min", "bed_count_max"],
      ["square_footage_min", "square_footage_max"],
      ["patient_discharge_min", "patient_discharge_max"],
      ["net_income_margin_min", "net_income_margin_max"],
      ["net_patient_revenue_min", "net_patient_revenue_max"],
    ].some(([minKey, maxKey]) => isInvalidRange(minKey, maxKey));

    return isEmpty || invalidMinMax;
  };

  const closeSearchSaveModal = async () => {
    setIsOpenSaveModal(false);
    // if (editingItem === null) {
    //   await applyingFilters();
    // }
    setEditingItem(null);
  };

  const applyingFilters = async () => {
    // resetUrl();
    // dispatch(resetSelectedState());
    // dispatch(resetSpecificStateData());
    await fetchFilteredHospitalsData();
    onCancel && onCancel();
  };

  const addSearchHistoryItem = async (title, editId = null) => {
    if (editId) {
      setSearchHistory((prev) =>
        prev.map((item) =>
          item.id === editId ? { ...item, title: title } : item,
        ),
      );
    } else {
      const newItem = {
        id: new Date().getTime(),
        title,
        filteredData: filteredData,
      };
      setSearchHistory((prev) => [...prev, newItem]);
    }
  };

  const editSearchHistoryItem = (e, itemId) => {
    e.stopPropagation();
    const itemToEdit = searchHistory.find((item) => item.id === itemId);
    setEditingItem(itemToEdit);
    setIsOpenSaveModal(true);
  };

  const deleteSearchHistoryItem = (e, itemId) => {
    e.stopPropagation();
    const filteredData = searchHistory.filter((item) => item.id !== itemId);
    setSearchHistory(filteredData);
  };

  const handleSelectSearchItem = (selectedItemId) => {
    const data = searchHistory.find((item) => item.id === selectedItemId);
    setFilteredData(data?.filteredData);
    setSelectedSearchItemId(selectedItemId);
  };

  useEffect(() => {
    const updateFooterPosition = () => {
      if (rightPopupRef.current) {
        const rightPopupTop = rightPopupRef.current.getBoundingClientRect().top;
        const viewportHeight = window.innerHeight;

        // Calculate bottom percentage dynamically
        const bottomPercentage =
          ((viewportHeight -
            (rightPopupTop + rightPopupRef.current.offsetHeight)) /
            viewportHeight) *
          100;
        setFooterBottom(bottomPercentage - 0.1234);
      }
    };

    updateFooterPosition();
    window.addEventListener("resize", updateFooterPosition);
    return () => window.removeEventListener("resize", updateFooterPosition);
  }, []);

  // console.log("🧪 current filteredData:", filteredData);  

  useEffect(() => {
    if (!matchedHospital) return;

    // Only update facility_type if it's empty or doesn't match
    if (
      matchedHospital.fac_type &&
      (!filteredData.facility_type || 
       !matchedHospital.fac_type.toLowerCase().includes(filteredData.facility_type.toLowerCase()) &&
       !filteredData.facility_type.toLowerCase().includes(matchedHospital.fac_type.toLowerCase()))
    ) {
      handleInputChange("facility_type", matchedHospital.fac_type);
    }

    // Only update prov_control_type if it's empty
    if (
      matchedHospital.prov_control_type &&
      (!filteredData.prov_control_type || filteredData.prov_control_type !== matchedHospital.prov_control_type)
    ) {
      handleInputChange("prov_control_type", matchedHospital.prov_control_type);
    }
  }, [matchedHospital, filteredData]);

  const prevHospitalNameRef = useRef(filteredData.hospital_name);
  useEffect(() => {
    const prevHospitalName = prevHospitalNameRef.current;
    prevHospitalNameRef.current = filteredData.hospital_name;

    // Only clear the auto-filled Facility Type / Ownership when a previously
    // selected hospital is actually deselected. Running this on every empty
    // hospital_name (e.g. on mount/reopen) would wipe filters the user set
    // manually. Clear both in a single update so one value can't clobber the
    // other via a stale state snapshot.
    if (prevHospitalName && !filteredData.hospital_name) {
      setFilteredData((prev) => ({
        ...prev,
        facility_type: "",
        prov_control_type: "",
      }));
    }
  }, [filteredData.hospital_name, setFilteredData]);

  const hiddenCategories = [
    "Oncology Focus",
    "Affiliations",
    "Reputation",
    "Accreditations",
    "Quality of Care",
    "Patient Experience",
    "Accessibility & Inclusivity",
  ];

  return (
    <>
      <RightPopup ref={rightPopupRef}>
        <Locations
          reference={locationRef}
          data={AdvancedFilterMap[0]}
          filteredData={filteredData}
          setFilteredData={setFilteredData}
          handleInputChange={handleInputChange}
          handleRadioChange={handleRadioChange}
          suggestionsList={suggestionsList}
          suggestionsLoader={suggestionsLoader}
          isFetching={isFetching}
          onMatchedHospitalChange={setMatchedHospital}
          onFieldSuggestionsChange={handleFieldSuggestionsChange}
        />
        <Facilities
          reference={facilitiesRef}
          data={AdvancedFilterMap[1]}
          filteredData={filteredData}
          setFilteredData={setFilteredData}
          handleInputChange={handleInputChange}
          handleRadioChange={handleRadioChange}
          dropdownSuggestions={dropdownSuggestions}
          suggestionsList={suggestionsList}
          suggestionsLoader={suggestionsLoader}
          onFieldSuggestionsChange={handleFieldSuggestionsChange}
          matchedHospital={matchedHospital}
          onReset={handleReset}
        />
        {/* {console.log("Matched hospital passed to Facilities:", matchedHospital)} */}
        {/* <OncologyFocus
              reference={oncologyRef}
              data={AdvancedFilterMap[2]}
            /> */}
        <FinancialAndOperational
          reference={financialAndOperationalRef}
          data={AdvancedFilterMap[3]}
          filteredData={filteredData}
          handleInputChange={handleInputChange}
        />
        {/* <Reputation reference={reputationRef} data={AdvancedFilterMap[4]} />
            <Affiliations
              reference={affiliationsRef}
              data={AdvancedFilterMap[5]}
            /> */}
        {/* <Accreditations
              reference={accreditationsRef}
              data={AdvancedFilterMap[6]}
            /> */}
        {/* <QualityOfCare
              reference={qualityOfCareRef}
              data={AdvancedFilterMap[7]}
              handleInputChange={handleInputChange}
            />
            <PatientExperience
              reference={patientExperienceRef}
              data={AdvancedFilterMap[8]}
              handleInputChange={handleInputChange}
            /> */}
        {/* <AccessibilityAndInclusivity
              reference={accessibilityAndInclusivityRef}
              data={AdvancedFilterMap[9]}
            /> */}
        {/* <SearchHistory
          reference={searchHistoryRef}
          data={AdvancedFilterMap[10]}
          searchData={searchHistory}
          handleEditItem={editSearchHistoryItem}
          handleDeleteItem={deleteSearchHistoryItem}
          selectedSearchItemId={selectedSearchItemId}
          handleSelectSearchItem={handleSelectSearchItem}
        /> */}

      </RightPopup>
      <SaveSearchModal
        isOpen={isOpenSaveModal}
        onClose={closeSearchSaveModal}
        handleAddItem={addSearchHistoryItem}
        editItem={editingItem}
        setIsOpenSaveModal={setIsOpenSaveModal}
        setIsSaveSearchChecked={setIsSaveSearchChecked}
      />
       <Footer bottomValue={footerBottom}>
          <CheckboxContainer zIndex={10}>
            <input
              style={{
                cursor: "pointer",
                accentColor: "#F96250",
                width: viewSizeCalculator(1.0625),
                height: viewSizeCalculator(1.0625),
              }}
              type="checkbox"
              id={"save_this_search"}
              checked={isSaveSearchChecked}
              disabled={isDisabled(filteredData)}
              onChange={(e) => {
                setIsSaveAndApply(false);
                setIsSaveSearchChecked(e.target.checked);
                handleSaveSearch();
              }}
            />
            <CheckboxLabel htmlFor={"save_this_search"}>
              {"Save this Search"}
            </CheckboxLabel>
          </CheckboxContainer>
          <StyledButton onClick={onCancel} isCancel={true}>
            Cancel
          </StyledButton>
          <StyledButton
            disabled={isDisabled(filteredData)}
            bgColor={"#333333"}
            onClick={handleFilterApplied}
          >
            {" "}
            {showloader ? (
              <Loader
                height={viewSizeCalculator(1.5)}
                width={viewSizeCalculator(1.5)}
              />
            ) : isSaveAndApply ? (
              "Save & Apply"
            ) : (
              "Apply Filter"
            )}
          </StyledButton>
        </Footer>
    </>
  );
};

export default AdvanceFilterComponent;
